/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { SAVE_SUBSCRIPTIONS_SUCCESS } from 'state/subscriptions/SubscriptionsActions';
import { addToast } from 'state/toast/ToastActions';
import {
  analyticsActionError,
  analyticsActionSuccess
} from 'state/analytics/AnalyticsActions';

/**
 * Update subscriptions logic supports both Document Delivery and Subscriptions page toast notifications.
 */
const UpdateSubscriptionsLogic = createLogic({
  type: SAVE_SUBSCRIPTIONS_SUCCESS,

  process({ action }, dispatch, done) {
    const { response } = action;

    if (response) {
      // dispatch user message
      dispatch(addToast(true, 'Changes Saved'));

      // dispatch analytics message
      dispatch(
        analyticsActionSuccess('ProfPref', 'UpdateSubscriptionsPreferences')
      );
    } else {
      // dispatch user message
      const title = '';
      const message = 'There was an error updating your current subscriptions';
      dispatch(addToast(false, title, message));

      // dispatch analytics message
      dispatch(analyticsActionError('UpdateSubscriptionsPreferences'));
    }
    done();
  }
});

export default UpdateSubscriptionsLogic;
